import {
  Column,
  Label,
  CheckItem,
  UserInfo,
  Bookmark,
  Notification,
} from "@/types/task";
import { File } from "@/types/drive";
import Storage from "@/store/share/storage";
import calendar1401Data from "../app/calendar401.json";
import calendar1402Data from "../app/calendar402.json";
import { DEFAULT_COLUMN, DEFAULT_LABELS } from "@/types/constant";
import DateTime from "@/utils/date";

export type State = {
  searchText: string;
  isArchive: boolean;
  notifications: Notification[];
  loading: {
    text?: string;
    isOpen?: boolean;
  };
  isOpenLoginDialog: boolean;
  isOpenCalendar: boolean;
  isAddTaskOpen: boolean;
  addTaskDialogName: string | null;
  googleToken: string | null;
  googleFile: File | null;
  columns: Column[];
  labels: Label[];
  checkList: CheckItem[];
  bookmarks: Array<Bookmark | null>;
  userInfo: UserInfo | null;
  calendar: any;
  settings: {
    isDarkMode: boolean;
    isCheckListOpen: boolean;
    isOpenMobileSidebar: boolean;
    backgroundColor: string | null;
    backgroundImage: string | ArrayBuffer | null;
  };
};

export const defaultsBookmarks = (
  isWithDefaults?: boolean
): Array<Bookmark | null> => {
  const defaultsBookmarkCounts = 10;
  const bookmarks = new Array(defaultsBookmarkCounts).fill(null);

  if (isWithDefaults) {
    // Defaults bookmarks
    bookmarks[0] = {
      title: "google",
      url: "https://google.com",
    };
    bookmarks[1] = {
      title: "کیاس",
      url: "https://kias.ir",
    };
    bookmarks[2] = {
      title: "تسکبان",
      url: "https://taskban.ir",
    };
  }

  return bookmarks;
};

const storage = new Storage();

function getColumns() {
  const data = storage.get();
  if (data) {
    return data.columns;
  } else {
    return [...DEFAULT_COLUMN];
  }
}

function getCalendar() {
  const dateTime = new DateTime(new Date());
  switch (dateTime.getShYearFa()) {
    case "1401":
      return calendar1401Data;
    case "1402":
      return calendar1402Data;
  }
}

export const state: State = {
  // Share ===========
  searchText: "",
  isArchive: false,
  isOpenLoginDialog: false,
  isOpenCalendar: false,
  addTaskDialogName: null,
  calendar: getCalendar(),
  googleFile: storage.get()?.googleFile || null,
  notifications: [],
  loading: {
    isOpen: false,
    text: "",
  },
  isAddTaskOpen: false,

  // User ===========
  googleToken: storage.get()?.googleToken || null,
  userInfo: storage.get()?.userInfo || null,
  settings: {
    isDarkMode: storage.get()?.settings?.isDarkMode || false,
    isCheckListOpen:
      storage.get()?.settings?.isCheckListOpen === undefined
        ? true
        : storage.get()?.settings?.isCheckListOpen || false,
    isOpenMobileSidebar: false,
    backgroundColor: storage.get()?.settings?.backgroundColor || "F1F3F4",
    backgroundImage: storage.get()?.settings?.backgroundImage || null,
  },
  bookmarks: storage.get()?.bookmarks || defaultsBookmarks(true),

  // Tasks =======
  columns: getColumns(),
  labels: storage.get()?.labels || DEFAULT_LABELS,
  checkList: storage.get()?.checkList || [],
};
